import React from "react";
import PageShell from "../components/layout/PageShell";
import CinematicHero, { HeroOverlay } from "../components/layout/CinematicHero";
import Container from "../components/primitives/Container";
import Section from "../components/primitives/Section";
import Eyebrow from "../components/primitives/Eyebrow";
import Reveal from "../components/primitives/Reveal";
import LeaderCard from "../components/editorial/LeaderCard";
import ClosingStrip from "../components/editorial/ClosingStrip";
import SeoHead from "../components/seo/SeoHead";
import { IMAGES } from "../content/images";
import { LEADERSHIP } from "../content/site";

const Leadership = () => {
  return (
    <PageShell>
      <SeoHead
        title="Leadership"
        description="Quantum is led by a small group of investors and operators whose work is defined by long-term partnership and a preference for consequence over visibility."
        path="/leadership"
        ogImage={IMAGES.leadershipArchitectural}
      />
      <CinematicHero
        image={IMAGES.leadershipArchitectural}
        imageAlt="Architectural detail of a quiet institutional colonnade at first light."
        eager
        data-testid="leadership-hero"
      >
        <HeroOverlay
          eyebrow={LEADERSHIP.hero.eyebrow}
          title={LEADERSHIP.hero.headline}
          statement="A small group of investors and operators."
        />
      </CinematicHero>

      {/* Intro — single sentence */}
      <Section tone="light" className="pt-20 md:pt-24 lg:pt-28 pb-4 md:pb-6 lg:pb-6" data-testid="leadership-intro">
        <Container>
          <Reveal className="max-w-3xl">
            <Eyebrow tone="muted">An institution, quietly led</Eyebrow>
            <p
              className="mt-10 font-serif font-normal text-navy text-balance"
              style={{ fontSize: "clamp(28px, 3.4vw, 44px)", lineHeight: 1.25 }}
            >
              {LEADERSHIP.intro}
            </p>
          </Reveal>
        </Container>
      </Section>

      {/* Leaders grid */}
      <Section tone="offwhite" className="pt-4 md:pt-6 lg:pt-6 pb-16 md:pb-20 lg:pb-24" data-testid="leadership-grid">
        <Container>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 lg:gap-x-12 gap-y-20">
            {LEADERSHIP.leaders.map((l, i) => (
              <Reveal key={l.title} delay={i * 80}>
                <LeaderCard initials={l.initials} title={l.title} bio={l.bio} />
              </Reveal>
            ))}
          </div>
        </Container>
      </Section>

      <ClosingStrip>{LEADERSHIP.closing}</ClosingStrip>
    </PageShell>
  );
};

export default Leadership;
